__turbopack_context__.v({
  "verticalCenter": "A1ooTa_verticalCenter",
});
